import { planUtils } from 'utils/plan/plan.utils';

export const getIsSubExternalAa = (sub: Subscription, plan: Plan) => {
  const planType = planUtils.getType(plan);

  return (
    planType === 'active-active' &&
    Boolean(
      sub?.aa_rcp?.crdb_regions?.some((region) => region.cloud_account_ownership === 'external')
    )
  );
};
